import { render, staticRenderFns } from "./Database_modal.vue?vue&type=template&id=8854abde&scoped=true"
import script from "./Database_modal.vue?vue&type=script&lang=js"
export * from "./Database_modal.vue?vue&type=script&lang=js"
import style0 from "./Database_modal.vue?vue&type=style&index=0&id=8854abde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8854abde",
  null
  
)

export default component.exports